import { BaseClient } from '../client';

interface PostAdminUserRequest {
	idGrupoAcesso: number;
	concessionarias: number[];
	idRevenda: number;
	nome: string;
	email: string;
	telefone: string;
	senha: string;
	tagAtivo: string;
	tagNaoComprar: string;
	tagReceberEmail: string;
	tagReceberPush: string;
}

export const postAdmintUser = async (requestBody: PostAdminUserRequest) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 1234;
	// }

	try {
		const response = await BaseClient.post<string>(
			`/Admin/CreateAdminUsuario`,
			requestBody
		).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
